import { StateScheme } from 'app/providers/StoreProvider/config/StateScheme'

export const getTypeRating = (state: StateScheme) => {
	return state.filterRating.type
}
